import React, { PropsWithChildren } from 'react'
import { IMAGE_FILTER } from '../../utils/detectWebPSupported'
import renderRichText from '../../utils/richTextResolver'
import AtomixIcon from '../icons/AtomixIcon'
import classes from './ContactHeader.module.scss'
import { ISbRichtext } from 'storyblok-js-client'

export type ContactHeaderProps = {
  header_left: [
    {
      image: {
        filename: string
        alt: string
      }
      text: string
    }
  ]
  header_right: ISbRichtext
  component: string
}

const ContactHeader:React.FC<PropsWithChildren<ContactHeaderProps>> = ({ header_left, header_right })=> {
  const renderContactImage = ()=> {
    return (
      <>
        {header_left[0]?.image?.filename?.split('.').pop() === 'svg' ? (
          <object data={`${header_left[0]?.image?.filename}`} type="image/svg+xml" width="100%" height="100%">image</object>
        ) : (
          <img src={`${header_left[0]?.image?.filename}${IMAGE_FILTER}`} alt={header_left[0].image.alt} />
        )}
      </>
    )
  }

  return (
    <div className={classes.contactHeaderWrapper}>
      <div className={classes.headerLeft}>
        <div className={classes.headerLeftWrapper}>
          {header_left[0]?.image?.filename !== null ? renderContactImage(): null}
        </div>
        <h2 className={classes.headerTitle}>{header_left[0].text}</h2>
      </div>
      <div className={classes.headerRight}>
        <div className={classes.contactInfo}>
          <div dangerouslySetInnerHTML={{ __html: renderRichText(header_right) }} />
        </div>
      </div>
      <div className={classes.tellUsTag}>
        <span>
          Tell us about
        yourself…
        </span>
        <AtomixIcon className={classes['facegallery-cta__image']} iconCode={'upArrowFooterCta'} />
      </div>
    </div>
  )
}


export default ContactHeader
